import { render } from "./Slide.vue?vue&type=template&id=328c578c&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=328c578c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-328c578c"

export default script